module.exports = __webpack_public_path__ + "img/plan-01.325e7f8b.png";